import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { List } from 'immutable';
import { PropTypes } from 'prop-types';
import { connect } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilter } from "@fortawesome/free-solid-svg-icons";
import { Title } from '../layout';
import ViewResponsesComponent from './view-responses.component';
import { SearchBar, formElements } from '@social-solutions/ssg-forms';
import { numberUtils } from '../common';
import { formDefinition } from '@social-solutions/ssg-forms-processing';
import * as responsesActions from './responses.actions';
import './responses.scss';

const guidEmpty = numberUtils.convertIntToGuid(0); // 0 is a special touchpoint id which means, fetch all recent touchpoint responses regardless of id

/** the page that displays all previous responses */
export class ResponsesComponent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      searchValue: null,
      siteSelection: null,
      programSelection: null,
      expandFilter: false,
    }
  }

  /**
   * Handles the search button being clicked.
   * Causes the filter options for the query to be set, and collapses the filter controls on mobile
   */
  handleFilter(e) {
    const { responsesActions, responses } = this.props;
    const { searchValue, siteSelection, programSelection } = this.state;
    const { nameSearch, programId, siteId } = responses;
    e.preventDefault();


    const currentSearchValue = (searchValue !== null && searchValue !== undefined) ? searchValue : nameSearch;
    const selectedSiteId = (siteSelection !== null && siteSelection !== undefined) ? siteSelection : siteId;
    const selectedProgramId = (programSelection !== null && programSelection !== undefined) ? programSelection : programId;

    responsesActions.applyFilter(currentSearchValue, selectedSiteId, selectedProgramId);
    this.setState({expandFilter: false});
  }

  /**
   * Sets the selected site value in local state. (does not affect the api query)
   * Resets the program selection if the value changes.
   * @param {*} site a list of option values
   */
  handleSiteChange(site) {
    const { siteSelection } = this.state;
    var newSite = (site && site.size > 0) ? site.get(0) : "";
    if(newSite === "" || siteSelection !== newSite) {
      this.setState({programSelection: ""});
    }
    this.setState({siteSelection: newSite});
  }

  /**
   * Sets the selected program value in local state. (does not affect the api query)
   * @param {*} program a list of option values
   */
  handleProgramChange(program) {
    var newProgram = (program && program.size > 0) ? program.get(0) : "";
    this.setState({programSelection: newProgram});
  }

  /** Displays a SelectElement with all the sites as options */
  renderSiteDropdown() {
    const { programEnrollment, responses } = this.props;
    const { siteSelection } = this.state;
    const { siteId } = responses;

    const { enrollment } = programEnrollment;
    const { sites } = enrollment || {};
    var siteOptions = [{
      label: "All Locations",
      value: "",
    }];
    if(sites) {
      const siteList = sites.map(site => ({ label: site.name, value: site.siteId }));
      siteOptions.push(...siteList);
    }

    const sitesDropdown = {
      id: 'sites',
      label: '',
      ariaLabel: 'locations filter',
      type: formDefinition.elementTypes.select,
      options: siteOptions
    };

    return (
      <formElements.SelectElement
        disableEmptyOption={true}
        element={sitesDropdown}
        value={(siteSelection !== undefined && siteSelection !== null) ? List([siteSelection]) : undefined}
        defaultValue={(siteId !== undefined && siteId !== null) ? List([siteId]) : undefined}
        onChange={(val) => this.handleSiteChange(val)}/>
    );
  }

  /** Displays a SelectElement with all the programs as options, disabled if a site has not been selected */
  renderProgramDropdown() {
    const { programEnrollment, responses } = this.props;
    const { siteSelection, programSelection, } = this.state;
    const { programId, siteId } = responses;

    const { enrollment } = programEnrollment;
    const { sites } = enrollment || {};

    var programOptions = [{
      label: "All Programs/Services",
      value: "",
    }];
    const selectedSiteId = (siteSelection !== null && siteSelection !== undefined) ? siteSelection : siteId;
    if(selectedSiteId && sites) {
      const selectedSite = sites.find(site => site.siteId === selectedSiteId);
      const programList = selectedSite.programs ? selectedSite.programs.map(program => ({ label: !program.alias ? program.name : program.alias, value: program.programId })) : [];
      programOptions.push(...programList);
    }

    const programsDropdown = {
      id: 'programs',
      label: '',
      ariaLabel: 'programs filter',
      type: formDefinition.elementTypes.select,
      options: programOptions,
      disabled: !selectedSiteId,
    };

    return (
      <formElements.SelectElement
        disableEmptyOption={true}
        element={programsDropdown}
        value={(programSelection !== undefined && programSelection !== null) ? List([programSelection]) : undefined}
        defaultValue={(programId !== undefined && programId !== null) ? List([programId]) : undefined}
        onChange={(val) => this.handleProgramChange(val)}/>
    );
  }

  render() {
    const { responses } = this.props;
    const { nameSearch } = responses;
    const { searchValue, expandFilter } = this.state;

    return (
      <div>
        <Title title="Form Submissions"/>
        <div className="responses-header">
          <h1 className="ssg-forms-text xl page-title">Form Submissions</h1>
          <span>
            <button
              id='filterButton'
              className='ssg-forms-icon-btn responses-filter-btn'
              title="Filter"
              aria-label={expandFilter ? 'collapse filter options' : 'expand filter options'}
              onClick={e => this.setState({expandFilter: !expandFilter})}>
              <FontAwesomeIcon icon={faFilter}/>
            </button>
          </span>
          <form className={`responses-filter${expandFilter ? "" : " collapsed"}`}>
            <SearchBar
              ariaLabel="filter form submissions"
              value={searchValue}
              defaultValue={nameSearch}
              onChange={(val) => this.setState({searchValue: val})}
              css={{group: "responses-search"}}/>
            <span className="ssg-forms-text normal responses-sites-section">View</span>
            {this.renderSiteDropdown()}
            {this.renderProgramDropdown()}
            <span>
              <button
                type="submit"
                className="ssg-forms-btn ssg-forms-btn-primary responses-search-button"
                onClick={(e) => this.handleFilter(e)}>
                Search
              </button>
            </span>
          </form>
        </div>
        <div>
          <ViewResponsesComponent
            formId={guidEmpty}
            redirectUrl={"/responses"}/>
        </div>
      </div>
    );
  }
}

ResponsesComponent.propTypes = {
  auth: PropTypes.any.isRequired,
  routing: PropTypes.any.isRequired,
  programEnrollment: PropTypes.any.isRequired,
  responses: PropTypes.any.isRequired,
};

const mapStateToProps = ({ routing, auth, programEnrollment, responses }) => {
  return {
    auth,
    routing,
    programEnrollment,
    responses,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    responsesActions: bindActionCreators(responsesActions, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ResponsesComponent);



// WEBPACK FOOTER //
// src/responses/responses.component.js